// extracted by mini-css-extract-plugin
export var cost = "style-module--cost--b714a";
export var indi = "style-module--indi--963a5";
export var inner = "style-module--inner--f0fc6";
export var newPrice = "style-module--new-price--81d10";
export var oldPrice = "style-module--old-price--366b9";
export var otl = "style-module--otl--e3d4a";
export var price = "style-module--price--ea56f";
export var undertext = "style-module--undertext--61da2";